import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=72eda767&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72eda767')) {
      api.createRecord('72eda767', component.options)
    } else {
      api.reload('72eda767', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=72eda767&", function () {
      api.rerender('72eda767', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8KB4MFKRMApW9/JS/imageCarousel.vue"
export default component.exports